import api from 'Application/api/api';

const selectIntroductionPPE = (
    projectId,
    introductionId,
    ppe,
    cancelToken = null,
) =>
    api.post(
        `project-manager/projects/${projectId}/introductions/${introductionId}/select-ppe`,
        {
            ppe,
        },
        { cancelToken },
    );

export default selectIntroductionPPE;
